import { MemberTypeEnum } from '../models/permissionsmodel';
import { ISettingsModel, Settings } from '../models/settingsmodel';
import { TrainingDayLogv2 } from '../models/traininghistorymodel';
import { WorkoutModelDBv2 } from '../models/trainingmodel';
import { IUser, User } from '../models/usermodel';
import { migrationToTrainingDayLogv2, migrationToWorkoutModelDBv2 } from './data-migration-utilities';

import { tfpapi } from './trainfitpro-apiservice';

// Allow dependency injection for testing
import { createApiInjector } from './api-injector';
export const userApiInjector = createApiInjector(tfpapi);

export function mockGetClients(): IUser[] {
  return [
    // new User({version: 1, id: '1', img: '/assets/profiles/abstral-official-DfXFZhIGz1A.webp', firstName: 'Yasmin', lastName: 'Almeida Nunes', memberType: MemberTypeEnum.client, roles: {}}),
    // new User({version: 1, id: '2', img: '/assets/profiles/abstral-official-TbpmPtI66Hk.webp', firstName: 'Larissa', lastName: 'Mendes Carvalho', memberType: MemberTypeEnum.client, roles: {}}),
    // new User({version: 1, id: '3', img: '/assets/profiles/alexander-hipp-iEEBWgY_6lA.webp', firstName: 'Lucas', lastName: 'Oliveira Santos', memberType: MemberTypeEnum.client, roles: {}}),
    // new User({version: 1, id: '4', img: '/assets/profiles/allef-vinicius-9417pueOkiE.webp', firstName: 'Valentina', lastName: 'Lima Oliveira', memberType: MemberTypeEnum.client, roles: {}}),
    // new User({version: 1, id: '5', img: '/assets/profiles/brooke-cagle-Nm70URdtf3c.webp', firstName: 'Gabriel', lastName: 'Souza Pereira', memberType: MemberTypeEnum.client, roles: {}}),
    // new User({version: 1, id: '6', img: '/assets/profiles/caju-gomes-EtSQMZft2Qc.webp', firstName: 'Juliana', lastName: 'Silva Castro', memberType: MemberTypeEnum.client, roles: {}}),
    // new User({version: 1, id: '7', img: '/assets/profiles/carlos-silva-cyOKLSgkgCE.webp', firstName: 'Bruno', lastName: 'Pereira Martins', memberType: MemberTypeEnum.client, roles: {}}),
    // new User({version: 1, id: '8', img: '/assets/profiles/christina-wocintechchat-com-0Zx1bDv5BNY.webp', firstName: 'Isabela', lastName: 'Oliveira Santos', memberType: MemberTypeEnum.client, roles: {}}),
    // new User({version: 1, id: '9', img: '/assets/profiles/christina-wocintechchat-com-SJvDxw0azqw.webp', firstName: 'Letícia', lastName: 'Barbosa Almeida', memberType: MemberTypeEnum.client, roles: {}}),
    // new User({version: 1, id: '10', img: '/assets/profiles/christopher-campbell-rDEOVtE7vOs.webp', firstName: 'Amanda', lastName: 'Nunes Ribeiro', memberType: MemberTypeEnum.client, roles: {}}),
    // new User({version: 1, id: '11', img: '/assets/profiles/daniel-monteiro-w8wpFqiMpW8.webp', firstName: 'Giovanna', lastName: 'Alves Ferreira', memberType: MemberTypeEnum.client, roles: {}}),
    // new User({version: 1, id: '12', img: '/assets/profiles/gabriel-brito-xn9aMsBTi9o.webp', firstName: 'Camila', lastName: 'Rocha Lima', memberType: MemberTypeEnum.client, roles: {}}),
    // new User({version: 1, id: '13', img: '/assets/profiles/gabriel-silverio-bUwjJ-KZ280.webp', firstName: 'Gabriela', lastName: 'Rodrigues Costa', memberType: MemberTypeEnum.client, roles: {}}),
    // new User({version: 1, id: '14', img: '/assets/profiles/jack-finnigan-rriAI0nhcbc.webp', firstName: 'Henrique', lastName: 'Martins Silva', memberType: MemberTypeEnum.client, roles: {}}),
    // new User({version: 1, id: '15', img: '/assets/profiles/juan-encalada-WC7KIHo13Fc.webp', firstName: 'Felipe', lastName: 'Kawasaki', memberType: MemberTypeEnum.client, roles: {}}),
    // new User({version: 1, id: '16', img: '/assets/profiles/michael-dam-mEZ3PoFGs_k.webp', firstName: 'Rafaela', lastName: 'Pereira Martins', memberType: MemberTypeEnum.client, roles: {}}),
    // new User({version: 1, id: '17', img: '/assets/profiles/nando-martins-aqlWQrsEgdk.webp', firstName: 'Luana', lastName: 'Ferreira Rocha', memberType: MemberTypeEnum.client, roles: {}}),
    // new User({version: 1, id: '18', img: '/assets/profiles/nando-martins-i9vroYHYV7A.webp', firstName: 'Cauã', lastName: 'Santos Mendes', memberType: MemberTypeEnum.client, roles: {}}),
    // new User({version: 1, id: '19', img: '/assets/profiles/nando-martins-XUcFi0mP5Us.webp', firstName: 'Bruna', lastName: 'Martins Silva', memberType: MemberTypeEnum.client, roles: {}}),
    // new User({version: 1, id: '20', img: '/assets/profiles/oguz-yagiz-kara-MZf0mI14RI0.webp', firstName: 'Leonardo', lastName: 'Mendes Carvalho', memberType: MemberTypeEnum.client, roles: {}}),
    // new User({version: 1, id: '21', img: '/assets/profiles/philipe-cavalcante-397mimKyA1U.webp', firstName: 'Mariana', lastName: 'Cavalcanti Souza', memberType: MemberTypeEnum.client, roles: {}}),
    // new User({version: 1, id: '22', img: '/assets/profiles/pietra-schwarzler-buNlKDDFy4A.webp', firstName: 'Alice', lastName: 'Ribeiro Cavalcanti', memberType: MemberTypeEnum.client, roles: {}}),
    // new User({version: 1, id: '23', img: '/assets/profiles/romina-farias-BsZ71j4i_m4.webp', firstName: 'Eloá', lastName: 'Santos Mendes', memberType: MemberTypeEnum.client, roles: {}}),
    // new User({version: 1, id: '24', img: '/assets/profiles/vince-veras-AJIqZDAUD7A.webp', firstName: 'Beatriz', lastName: 'Souza Pereira', memberType: MemberTypeEnum.client, roles: {}}),
    // new User({version: 1, id: '25', img: '/assets/profiles/vinicius-henrique-photography-FKeGskJ0Ivs.webp', firstName: 'Victor', lastName: 'Barbosa Almeida', memberType: MemberTypeEnum.client, roles: {}}),
  ];
}

export class UserService {

  static async getUser(uid: string) : Promise<User> {

    const result = await userApiInjector.api.system.dtls.getOne({ providerUserUUID: uid });

    const user = result.data && result.data.success && result.data.result;

    if (!user) {
      throw Error('User not found');
    }

    // the cast there to circumvent undefined vs null definitions
    // of the same properties
    return new User(user as IUser);

  }

  static async getTrainers(uid: string) : Promise<User[]> {
    const result = await userApiInjector.api.user.trainers.get({ userUUID: uid });

    if (!(result.data && result.data.success && result.data.result)) {
      throw Error('User not found');
    }

    return (result.data?.result ?? []).map((t) => new User({
      ...t,
      providerUserUUID: 'unknown',
      memberType: MemberTypeEnum.trainer,
      phone: t.phone ?? undefined,
      lastLogin: t.lastLogin ?? undefined,
    }));
  }

  static async updateUser(user: IUser) {

    const result = await userApiInjector.api.system.dtls.put({ providerUserUUID: user.providerUserUUID}, {
      img: user.img,
    });

    if (result.data && result.data.success) {
      return user;
    }

    throw Error('Failure updating user');
  }

  static async getSettings(uid: string) : Promise<Settings|null> {
    const result = await userApiInjector.api.user.settings.get({ userUUID: uid });

    if (result.data && result.data.success && result.data.result && result.data.result.length > 0) {
      const settings = result.data.result;
      return new Settings(settings[0].settings as unknown as ISettingsModel);
    } else {
      return null;
    }
  }

  static async setSettings(uid: string, settings: ISettingsModel) {
    // casts here as to work around not having to update settings model in the backend every time it changes
    const result = await userApiInjector.api.user.settings.set({ userUUID: uid }, { settings: settings as unknown as Record<string, never> });

    if (result.data && result.data.success) {
      return settings;
    }

    throw Error('Failure updating settings');
  }

  static async getComms(uid: string) {
    const result = await userApiInjector.api.user.comms({ userUUID: uid });

    if (result.data && result.data.success) {
      return result.data.result;
    }

    return { journals: [], chats: [] };
  }

  static async getWorkoutsFromAllTrainers(me: string): Promise<(WorkoutModelDBv2 & { trainerUUID: string })[]> {
    const result = await userApiInjector.api.user.trainers.workouts.get({ userUUID: me });

    if (result.data && result.data.success) {
      const plans: (Parameters<typeof migrationToWorkoutModelDBv2>[0])[]
        = result.data.result.map((r) => ({ ...r, userUUID: null }));

      return plans.map(migrationToWorkoutModelDBv2) as (WorkoutModelDBv2 & { trainerUUID: string })[];
    }

    return [];
  }

  static async getAllWorkoutLogsFromAllTrainers(me: string): Promise<(TrainingDayLogv2 & { trainerUUID: string })[]> {
    const result = await userApiInjector.api.user.workouts.logs.get({ userUUID: me });

    if (result.data && result.data.success) {
      return result.data.result.map(migrationToTrainingDayLogv2) as (TrainingDayLogv2 & { trainerUUID: string })[];
    }

    return [];
  }

}
